import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import { TenantDetailsApi } from '@/common/models';
import { Button } from '@/external/telstra-ui-vue/components';

@Component({
  components: {
    Button,
  },
})
export default class TenantDetailsHeader extends Vue {

  @Prop({ required: true }) tenantDetails!: TenantDetailsApi;

  @Emit()
  goBack() {
    this.$emit('goBack');
  }

  @Emit()
  manageUsers() {
    this.$emit('manageUsers');
  }

}
